var _rect, _rect2, _rect3, _path, _path2, _path3, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInstagram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 14,
    height: 14,
    rx: 4,
    fill: "url(#paint0_radial_1280_14647)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 14,
    height: 14,
    rx: 4,
    fill: "url(#paint1_radial_1280_14647)"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 1,
    width: 14,
    height: 14,
    rx: 4,
    fill: "url(#paint2_radial_1280_14647)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5.25C11.5 5.66421 11.1642 6 10.75 6C10.3358 6 10 5.66421 10 5.25C10 4.83579 10.3358 4.5 10.75 4.5C11.1642 4.5 11.5 4.83579 11.5 5.25Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 10.5C9.38071 10.5 10.5 9.38071 10.5 8C10.5 6.61929 9.38071 5.5 8 5.5C6.61929 5.5 5.5 6.61929 5.5 8C5.5 9.38071 6.61929 10.5 8 10.5ZM8 9.5C8.82843 9.5 9.5 8.82843 9.5 8C9.5 7.17157 8.82843 6.5 8 6.5C7.17157 6.5 6.5 7.17157 6.5 8C6.5 8.82843 7.17157 9.5 8 9.5Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3 7.8C3 6.11984 3 5.27976 3.32698 4.63803C3.6146 4.07354 4.07354 3.6146 4.63803 3.32698C5.27976 3 6.11984 3 7.8 3H8.2C9.88016 3 10.7202 3 11.362 3.32698C11.9265 3.6146 12.3854 4.07354 12.673 4.63803C13 5.27976 13 6.11984 13 7.8V8.2C13 9.88016 13 10.7202 12.673 11.362C12.3854 11.9265 11.9265 12.3854 11.362 12.673C10.7202 13 9.88016 13 8.2 13H7.8C6.11984 13 5.27976 13 4.63803 12.673C4.07354 12.3854 3.6146 11.9265 3.32698 11.362C3 10.7202 3 9.88016 3 8.2V7.8ZM7.8 4H8.2C9.05658 4 9.63887 4.00078 10.089 4.03755C10.5274 4.07337 10.7516 4.1383 10.908 4.21799C11.2843 4.40973 11.5903 4.71569 11.782 5.09202C11.8617 5.24842 11.9266 5.47262 11.9624 5.91104C11.9992 6.36113 12 6.94342 12 7.8V8.2C12 9.05658 11.9992 9.63887 11.9624 10.089C11.9266 10.5274 11.8617 10.7516 11.782 10.908C11.5903 11.2843 11.2843 11.5903 10.908 11.782C10.7516 11.8617 10.5274 11.9266 10.089 11.9624C9.63887 11.9992 9.05658 12 8.2 12H7.8C6.94342 12 6.36113 11.9992 5.91104 11.9624C5.47262 11.9266 5.24842 11.8617 5.09202 11.782C4.71569 11.5903 4.40973 11.2843 4.21799 10.908C4.1383 10.7516 4.07337 10.5274 4.03755 10.089C4.00078 9.63887 4 9.05658 4 8.2V7.8C4 6.94342 4.00078 6.36113 4.03755 5.91104C4.07337 5.47262 4.1383 5.24842 4.21799 5.09202C4.40973 4.71569 4.71569 4.40973 5.09202 4.21799C5.24842 4.1383 5.47262 4.07337 5.91104 4.03755C6.36113 4.00078 6.94342 4 7.8 4Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_1280_14647",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6 11.5) rotate(-55.3758) scale(12.7598)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B13589"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79309,
    stopColor: "#C62F94"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A3AC8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_1280_14647",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.5 15.5) rotate(-65.1363) scale(11.2971)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#E0E8B7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.444662,
    stopColor: "#FB8A2E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.71474,
    stopColor: "#E2425C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E2425C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_1280_14647",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(0.250001 1.5) rotate(-8.1301) scale(19.4454 4.15918)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156701,
    stopColor: "#406ADC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.467799,
    stopColor: "#6A45BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#6A45BE",
    stopOpacity: 0
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.02cebcab72a6049e3ff0f643f3bb5544.svg";
export { ForwardRef as ReactComponent };